import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TablePagination,
	TableRow,
} from '@material-ui/core';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import getEditHistory from '../../../api/Siteplan/getEditHistory.api';
import { camelCaseToString } from '../../../utils/camelCaseToString';
import styles from './ViewHistory.module.scss';

const ViewHistory = ({ historyTrails, resetPage }) => {
	const [order, setOrder] = useState('asc');
	const [orderBy, setOrderBy] = useState('calories');
	const [selected, setSelected] = useState([]);
	const [page, setPage] = useState(0);
	const [dense, setDense] = useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(5);

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	function descendingComparator(a, b, orderBy) {
		if (b[orderBy] < a[orderBy]) {
			return -1;
		}
		if (b[orderBy] > a[orderBy]) {
			return 1;
		}
		return 0;
	}

	function getComparator(order, orderBy) {
		return order === 'desc'
			? (a, b) => descendingComparator(a, b, orderBy)
			: (a, b) => -descendingComparator(a, b, orderBy);
	}

	function stableSort(array, comparator) {
		const stabilizedThis = array.map((el, index) => [el, index]);
		stabilizedThis.sort((a, b) => {
			const order = comparator(a[0], b[0]);
			if (order !== 0) return order;
			return a[1] - b[1];
		});
		return stabilizedThis.map((el) => el[0]);
	}

	useEffect(() => {
		console.log('historyTrails', historyTrails);
	}, [historyTrails]);

	useEffect(() => {
		if (resetPage) {
			setPage(0);
		}
	}, [resetPage]);

	return (
		<div className={styles.history_table}>
			<Table className={styles.table} aria-label='Lot assignment table'>
				<TableHead>
					<TableRow>
						<TableCell align='center'>Date Modified</TableCell>
						<TableCell align='center'>Subject</TableCell>
						<TableCell align='center'>From</TableCell>
						<TableCell align='center'>To</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{historyTrails &&
						stableSort(
							historyTrails.reverse(),
							getComparator(order, orderBy)
						)
							.slice(
								page * rowsPerPage,
								page * rowsPerPage + rowsPerPage
							)
							.map((history) => {
								var sculptOldValue;
								var sculptNewValue;
								const { timestamp, value, oldValue, newValue } =
									history;
								if (value === 'salesAgent') {
									sculptOldValue = oldValue?.join(', ');
									sculptNewValue = newValue?.join(', ');
								} else {
									sculptOldValue = oldValue;
									sculptNewValue = newValue;
								}
								return (
									<TableRow>
										<TableCell align='center'>
											{dayjs(timestamp).format(
												'DD MMM YYYY @ hh:mm A'
											)}
										</TableCell>
										<TableCell align='center'>
											{camelCaseToString(value)}
										</TableCell>
										<TableCell align='center'>
											{sculptOldValue}
										</TableCell>
										<TableCell align='center'>
											{sculptNewValue}
										</TableCell>
									</TableRow>
								);
							})}
				</TableBody>
			</Table>
			<TablePagination
				rowsPerPageOptions={[5, 10, 25, 50]}
				component='div'
				count={historyTrails?.length}
				rowsPerPage={rowsPerPage}
				page={page}
				onPageChange={handleChangePage}
				onRowsPerPageChange={handleChangeRowsPerPage}
				className='tablePagination'
				labelRowsPerPage={
					<div style={{ color: 'var(--text-high-emphasis)' }}>
						Rows per page
					</div>
				}
				nextIconButtonProps={{
					style: {
						padding: '0px',
					},
				}}
				backIconButtonProps={{
					style: {
						padding: '0px',
						marginLeft: '-10px',
					},
				}}
				SelectProps={{
					style: {
						border: '1px solid var(--text-mid-emphasis)',
						borderRadius: '4px',
						padding: '4px',
						marginRight: '10px',
					},
				}}
			/>
		</div>
	);
};

export default ViewHistory;
